import TaxiCorporationFleetPartnerAddRequest from "../../../../api/raily/taxi-corporation/fleet-partner/add/taxi-corporation-fleet-partner-add.request";
import TaxiCorporationFleetPartnerAddParams from "./taxi-corporation-fleet-partner-add-params";

const create = (
  params: TaxiCorporationFleetPartnerAddParams,
): TaxiCorporationFleetPartnerAddRequest => {
  return {
    taxiCorporationUuid: params.taxiCorporationUuid,
    name: params.name,
    notes: params.notes,
  };
};

const taxiCorporationFleetPartnerAddParamsFactory = { create };

export default taxiCorporationFleetPartnerAddParamsFactory;
